import type {ReactElement} from 'react';
import {useState} from 'react';
import styles from './share-social-post-in-team-toggler.module.scss';
import {shareSocialMediaPostInTeam} from '@Libraries/social-media-post.library';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize} from '@Components/text';
import {ToggleSwitch, ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import {ToggleSwitchStyleVariant} from '@Components/toggle-switch-v2/toggle-switch-v2.types';
import {SocialMediaTestId} from '@/test-ids/social-media-test-id';
import type {ShareSocialPostInTeamTogglerProps} from './share-social-post-in-team-toggler.types';

export function ShareSocialPostInTeamToggler({post, gaEvent = '', className = ''}: ShareSocialPostInTeamTogglerProps): ReactElement {
  const [isLoading, setIsLoading] = useState(false);
  const [isSharedInTeam, setIsSharedInTeam] = useState(post.isSharedInTeam);

  const updateSharingStatus = async (shouldShareInTeam: boolean): Promise<void> => {
    setIsLoading(true);
    await shareSocialMediaPostInTeam(shouldShareInTeam, post.id);
    setIsLoading(false);
    setIsSharedInTeam(shouldShareInTeam);

    if (shouldShareInTeam && gaEvent) {
      window.PMW.gtm.trackGA4CustomEvent(gaEvent);
    }
  };

  const onToggleSwitched = (): void => {
    void updateSharingStatus(!isSharedInTeam);
  };

  return (
    <div className={`${styles.shareInTeamToggler} ${className}`}>
      <div className={styles.shareInTeamLabel}>
        <Icon icon="icon-team" size={IconSize.SIZE_ICON_16} type={IconType.NONE} />
        <Text val={window.i18next.t('pmwjs_share_in_team')} size={TextSize.MD} className="ct-neutral-primary" />
      </div>
      <ToggleSwitch
        isChecked={isSharedInTeam}
        isDisabled={isLoading}
        onChange={onToggleSwitched}
        ariaLabel={window.i18next.t('pmwjs_share_in_team')}
        size={ToggleSwitchV2Size.MEDIUM}
        variant={ToggleSwitchStyleVariant.COMPACT}
        data-testid={SocialMediaTestId.WIZARD_SHARE_IN_TEAM_TOGGLE}
      />
    </div>
  );
}
